export const environment = {
  production: true,
  staging: false,
  apiUrl: '/api/v2',
  version: '0.1.0'
};